import { render, staticRenderFns } from "./PointIndex.vue?vue&type=template&id=1e138f52&scoped=true&"
import script from "./PointIndex.vue?vue&type=script&lang=js&"
export * from "./PointIndex.vue?vue&type=script&lang=js&"
import style0 from "./PointIndex.vue?vue&type=style&index=0&id=1e138f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e138f52",
  null
  
)

export default component.exports